module.exports = __webpack_public_path__ + "23cdc2a00fb83e71a23cc01f98da32ae.MP3";